
import React from "react";
// nodejs library that concatenates strings
import classnames from "classnames";
import { Link, animateScroll as scroll } from "react-scroll";
import Logo from "../../assets/img/logoSEB_2.png";
// reactstrap components
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 90 ||
        document.body.scrollTop > 89
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 90 ||
        document.body.scrollTop < 90
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <Navbar className={classnames("fixed-top", navbarColor)} expand="lg">
      <Container >
        <div className="navbar-translate">
          <NavbarBrand
            data-placement="bottom"           
            title="Programa de Estágio - Grupo SEB"
          >
             <Link to="top" spy={true} smooth={true} offset={-50} duration={1000} style={{cursor:"pointer"}}>
            <img src={Logo} width="70" />
            </Link>
          </NavbarBrand>
          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse,
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse
          className="justify-content-end"
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>            
            <NavItem>
              <NavLink>
                  <Link to="vemserseb" spy={true} smooth={true} offset={-130} duration={1000} style={{textTransform:"none", fontSize:14, fontWeight:400, cursor:"pointer"}}>#VEMSERSEB</Link>                
              </NavLink>
            </NavItem>
            <NavItem>
            <NavLink>
                  <Link to="oprograma" spy={true} smooth={true} offset={-100} duration={1000} style={{textTransform:"none", fontSize:16, fontWeight:400, cursor:"pointer"}}>O Programa</Link>                
              </NavLink>
            </NavItem>
            <NavItem>
            <NavLink>
                  <Link to="requisitos" spy={true} smooth={true} offset={-130} duration={1000} style={{textTransform:"none", fontSize:16, fontWeight:400, cursor:"pointer"}}>Requisitos</Link>                
              </NavLink>
            </NavItem>
            <NavItem>
            <NavLink>
                  <Link to="vantagens" spy={true} smooth={true} offset={-100} duration={1000} style={{textTransform:"none", fontSize:16, fontWeight:400, cursor:"pointer"}}>Vantagens</Link>                
              </NavLink>
            </NavItem>
            <NavItem>
            <NavLink>
                  <Link to="etapas" spy={true} smooth={true} offset={-100} duration={1000} style={{textTransform:"none", fontSize:16, fontWeight:400, cursor:"pointer"}}>Etapas</Link>                
              </NavLink>
            </NavItem>
            <NavItem>
            <NavLink
                href="/oportunidades"
                style={{textTransform:"none",  fontWeight:400, fontSize:16, cursor:"pointer"}}
              >
                  Oportunidades            
              </NavLink>
            </NavItem>
            <NavItem>
            <Button
                className="btn-round"
                style={{backgroundColor:"#E4E140",color:"#41599E", display:"none", textTransform:"none", borderColor:"transparent", fontSize:16, fontWeight:600, }}
                href="https://www.vagas.com.br/v2303131/"
                target="_blank"
              >
                Inscreva-se!

              </Button>           
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default IndexNavbar;
